import React, { useCallback } from 'react';

import { useGetAvailableModelsQuery } from '../../../../api/endpoints/chat/settings-endpoints';
import { IConversationBase } from '../../../../api/types';
import { useUpdateConversation } from '../../../../redux/hooks/answer/conversation-hooks';
import { OptionType, Select } from '../../../Controls/Select/Select';

import { DEFAULT_MODEL, selectModelStyles } from './consts';

import styles from './SelectModel.module.scss';

interface SelectModelProps {
    conversation: IConversationBase;
}

export const SelectModel: React.FC<SelectModelProps> = ({ conversation }) => {
    const conversationId = conversation.conversation_id;
    const { updateModel } = useUpdateConversation(conversationId);
    const { data: models } = useGetAvailableModelsQuery(null);

    const onChange = useCallback(
        (model: string | string[] | undefined) => {
            if (!model || Array.isArray(model)) {
                return;
            }

            updateModel(conversationId, model);
        },
        [updateModel, conversationId]
    );

    if (!conversation) {
        return null;
    }

    const model = conversation.llm_config?.model ?? DEFAULT_MODEL;

    const options: OptionType[] =
        models?.map((model) => ({
            value: model.value,
            label: model.label,
        })) ?? [];

    return (
        <Select
            options={options}
            value={model}
            onChange={onChange}
            className={styles.select}
            customStyles={selectModelStyles}
            components={{
                // Hide the dropdown indicator
                DropdownIndicator: () => null,
            }}
        />
    );
};
